import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';
import {Button} from '@tickchak/react-share/app';
import {getAiAgentContext} from '../../../../redux/aiAgent/aiAgentActions';
import {isIntentAvailableInScope} from '../../utils/agentSchema';
import {AI_AGENT_SUGGESTIONS} from '../../constants';
import * as css from './AiAgentSuggestions.css';

interface AiAgentSuggestionsProps {
    onSuggestionClick: (prompt: string, index: number) => void;
}

function AiAgentSuggestions({onSuggestionClick}: AiAgentSuggestionsProps) {
    const {t} = useTranslation('aiAgent');
    // The scope comes from the pathname, so the offered actions follow the current page.
    const {pathname} = useLocation();

    const visibleSuggestions = useMemo(() => {
        const {scope} = getAiAgentContext();
        return AI_AGENT_SUGGESTIONS
            .map((suggestion, catalogIndex) => ({...suggestion, catalogIndex}))
            .filter(({intent}) => isIntentAvailableInScope(intent, scope));
    }, [pathname]);

    return (
        <css.suggestions>
            {visibleSuggestions.map(({Icon, labelKey, promptKey, catalogIndex}) => (
                <Button
                    key={labelKey}
                    variant="neutral"
                    size="category"
                    iconStart={<Icon width={20} height={20} fill="currentColor" />}
                    onClick={() => onSuggestionClick(t(promptKey), catalogIndex)}
                    data-cy={`account-ai-agent-suggestion-${catalogIndex}`}
                    customStyle={{borderColor: 'var(--color-border-subtle)'}}
                >
                    {t(labelKey)}
                </Button>
            ))}
        </css.suggestions>
    );
}

export default AiAgentSuggestions;
